import React from "react";

const CheckoutSection = ({ product }) => {
  return (
    <section className="py-8 bg-gray-50">
      <h2 className="text-center text-2xl font-bold mb-6">Checkout</h2>
      <div className="max-w-4xl mx-auto p-6 bg-white rounded-lg shadow-lg">
        {/* Resumen del producto */}
        <div className="bg-orange-50 p-4 rounded-md flex items-center mb-6">
          <img
            src={product.images[0]}
            alt={product.name}
            className="w-20 h-20 rounded-md mr-4"
          />
          <div>
            <h3 className="font-bold text-lg">{product.name}</h3>
            <p className="text-sm text-gray-700">0 days of warranty</p>
            <p className="text-sm text-green-500">Free shipping nationwide</p>
          </div>
        </div>

        {/* Formulario de compra */}
        <form className="space-y-4">
          {/* Cantidad */}
          <div className="flex items-center mb-6">
            <span className="mr-2 text-gray-700 font-bold">Quantity:</span>
            <button
              type="button"
              className="bg-gray-200 p-2 rounded-md text-gray-700 hover:bg-gray-300"
            >
              −
            </button>
            <span className="mx-4">1</span>
            <button
              type="button"
              className="bg-gray-200 p-2 rounded-md text-gray-700 hover:bg-gray-300"
            >
              +
            </button>
          </div>

          {/* Campos del formulario */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <input
              type="text"
              placeholder="Full Name"
              className="w-full p-2 border rounded"
            />
            <input
              type="email"
              placeholder="Email Address"
              className="w-full p-2 border rounded"
            />
            <input
              type="text"
              placeholder="Phone"
              className="w-full p-2 border rounded"
            />
            <input
              type="text"
              placeholder="Shipping Address"
              className="w-full p-2 border rounded"
            />
          </div>

          {/* Botón de confirmación */}
          <button
            type="submit"
            className="w-full bg-red-500 text-white py-3 px-6 rounded-lg shadow-lg hover:bg-red-600"
          >
            Confirm Purchase
          </button>
        </form>
      </div>
    </section>
  );
};

export default CheckoutSection;

